import React from "react";
import { motion, useReducedMotion } from "framer-motion";

/**
 * The single entrance animation used across the site: a short, small rise.
 * Everything shares one distance, one duration and one curve, so the page
 * reads as one product rather than a collection of effects.
 */
const EASE = [0.22, 1, 0.36, 1];

const Reveal = ({
  as = "div",
  delay = 0,
  y = 14,
  className = "",
  children,
  ...rest
}) => {
  const reduced = useReducedMotion();
  const Tag = motion[as] || motion.div;

  if (reduced) {
    const Plain = as;
    return (
      <Plain className={className} {...rest}>
        {children}
      </Plain>
    );
  }

  return (
    <Tag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.5, delay, ease: EASE }}
      className={className}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export { EASE };
export default Reveal;
